import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import { Text } from '@pbt/pbt-ui-components'

interface SystemMessagesFilteredEmptyStateProps {
  addConversationText: string
  onAddConversation: (() => void) | undefined
  onShowSystemMessages: () => void
  systemMessagesCount: number
}

export const SystemMessagesFilteredEmptyState = ({
  systemMessagesCount,
  onShowSystemMessages,
  addConversationText,
  onAddConversation,
}: SystemMessagesFilteredEmptyStateProps) => {
  const { t } = useTranslation(['Clients'])

  return (
    <Grid container p={1}>
      <Text mr={1} variant="lowAccent">
        {t('Clients:COMMUNICATION_WIDGET.NO_USER_MESSAGES')}
      </Text>
      <Text link mr={1} onClick={onShowSystemMessages}>
        {systemMessagesCount === 1
          ? t('Clients:COMMUNICATION_WIDGET.SHOW_SYSTEM_MESSAGE')
          : t('Clients:COMMUNICATION_WIDGET.SHOW_SYSTEM_MESSAGES_COUNT', {
              systemMessagesCount,
            })}
      </Text>
      {addConversationText && onAddConversation && (
        <Text link mr={1} onClick={onAddConversation}>
          {addConversationText}
        </Text>
      )}
    </Grid>
  )
}
